/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Full_BodyInputs */

const en_cap_full_body = /** @type {(inputs: Cap_Full_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Models, data, an AI gateway with budgets and fallbacks, self-hosted infrastructure and monitoring. One engineer owns all of it.`)
};

const lv_cap_full_body = /** @type {(inputs: Cap_Full_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modeļi, dati, AI vārteja ar budžetiem un rezerves ceļiem, pašu uzturēta infrastruktūra un uzraudzība. Par visu atbild viens inženieris.`)
};

/**
* | output |
* | --- |
* | "Models, data, an AI gateway with budgets and fallbacks, self-hosted infrastructure and monitoring. One engineer owns all of it." |
*
* @param {Cap_Full_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_full_body = /** @type {((inputs?: Cap_Full_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Full_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_full_body(inputs)
	return en_cap_full_body(inputs)
});